import { render, staticRenderFns } from "./allCustomerReviews.vue?vue&type=template&id=4080fbec&"
import script from "./allCustomerReviews.vue?vue&type=script&lang=js&"
export * from "./allCustomerReviews.vue?vue&type=script&lang=js&"
import style0 from "./allCustomerReviews.vue?vue&type=style&index=0&id=4080fbec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports